import { useSelector } from 'react-redux'
import Table from 'src/features/base/components/Table'
import { selectSelectedSalesChannels } from '../../StockAddressingInBatchSelectors'
import columns from './SelectedChannelsTable.columns'
import * as S from './SelectedChannelsTable.styles'

export default () => {
  const selectedSalesChannels = useSelector(selectSelectedSalesChannels)

  return (
    <S.Table
      as={Table}
      data={selectedSalesChannels}
      columns={columns}
      pageSize={selectedSalesChannels.length || 5}
    />
  )
}
